import { ApiHandler } from '@eshop/api-client'
import type Eshop from '@eshop/type/eshop'
import type { OptionalPropsUnion } from '@eshop/type/global'
import type Rental from '@eshop/type/rental'

export const ServiceProduct = {
    async getProductEshopByCode<T extends OptionalPropsUnion<Eshop.Body>>(this: void, codes: string | string[], parts: T[]) {
        if (!Array.isArray(codes)) {
            codes = [codes]
        }

        if (codes.length === 0) {
            return []
        }

        const api = new ApiHandler({
            path: '/product/get-products-eshop-by-codes',
            parameters: {
                codes,
                parts,
            },
        })
        // Takhle je to zatím formou nejmenšího odporu. Ale pak se to musí udělat správně.
        return (await api.send() ?? []) as (Eshop.Product<T> | null)[]
    },

    async getProductRentalByCode<T extends OptionalPropsUnion<Rental.Body>>(this: void, codes: string | string[], parts: Array<T>) {
        if (!Array.isArray(codes)) {
            codes = [codes]
        }

        if (codes.length === 0) {
            return []
        }

        const api = new ApiHandler({
            path: '/product/get-products-rental-by-codes',
            parameters: {
                codes,
                parts,
            },
        })
        // Takhle je to zatím formou nejmenšího odporu. Ale pak se to musí udělat správně.
        return (await api.send() ?? []) as (Rental.Product<T> | null)[]
    },
}
